import React from 'react';
import './TabSkip.scss';
import { HashLink as Link } from 'react-router-hash-link';

const TabSkip = ({ props }) => {
  const queryString = props?.queryString ? props.queryString : '';
  return (
    <div role='navigation' name="vai ai contenuti" className="visually-hidden header-skip">
      <ul className='header-skip-list'>
        <li>
          <Link
          name="link contenuto principale"
          to={`${queryString}#main-content`}
          tabIndex="0">
          Vai al contenuto della pagina
          </Link>
        </li>
        {props && !props.defaultSkip && (
          <>
            <li>
              <Link
                name="link sezione approfondimenti"
                className='ml-3'
                to={`${queryString}#above-content`}
                tabIndex="0">
                Vai alla sezione Approfondimenti  
              </Link>
            </li>
            <li>
              <Link 
                name="link sezione aggiornamenti"
                className='ml-3'
                to={`${queryString}#aside-content`}
                tabIndex="0">
                Vai alla sezione Aggiornamenti
              </Link>
            </li>
          </>
        )}
        <li>
          <Link
            name="link footer"
            className='ml-3'
            to={`${queryString}#footer`}
            tabIndex="0">
            Vai al footer della pagina
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default TabSkip;
